// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1W_Oh","active":"NavigationItem_active__1Vm_N"};